import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
  getActivitySubtaskFields() {
    return { 
            model: 'tasks_requirements', 
            label: 'Requirements',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true }
            ]}
  },
}

export const actions = {
  async fetchRequirements(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/requirements/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createRequirements(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/requirements/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateRequirements(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/requirements/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteRequirements(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/requirements/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}